"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ProjectDetailsPopover_1 = __importDefault(require("./ProjectDetailsPopover"));
exports.default = ProjectDetailsPopover_1.default;
